export function RequiredSpan () {
  return <span className='nh-required-span'>*Required</span>
}
